// in src/posts.js
import * as React from "react";
import {
  useNotify,
} from "react-admin";
import { FormTerm } from "./FormTerm";
import Edit from "../../baseComponents/Edit";

export const TermEdit = () => {
  const notify = useNotify();

  const onSuccess = () => {
    notify("ra.action.updated");
  };

  

  return (
    <Edit
      onSuccess={onSuccess}
    >
      <FormTerm></FormTerm>
    </Edit>
  );
};
